<template>
  <div class="text-neutral2-400 text-sm mt-1">
    <slot/>
  </div>
</template>
